import { ChangeEvent } from 'react'

import Select from '@totallymoney/ui/components/Select'

import { StyledSorterWrapper } from './TableSorter.styled'

interface TableSorterProps<TSortKey extends string> {
    onSortChange: (sortKey: TSortKey) => void
    sortOptions: Record<TSortKey, string>
    value: TSortKey
}

const TableSorter = <TSortKey extends string>({
    value,
    sortOptions,
    onSortChange,
}: TableSorterProps<TSortKey>) => {
    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        onSortChange(event.target.value as TSortKey)
    }

    return (
        <StyledSorterWrapper>
            <Select
                icon="sort"
                name="sortBy"
                onChange={handleChange}
                value={value}
                data-testid="table-sorter"
                aria-label="Sort the cards"
            >
                {Object.keys(sortOptions).map((key: string) => (
                    <option key={key} value={key}>
                        Sort by: {sortOptions[key as TSortKey] as string}
                    </option>
                ))}
            </Select>
        </StyledSorterWrapper>
    )
}

export default TableSorter
